var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerRestaurantIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#ca03ca"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "white"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000, 25.000) scale(0.025000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300-100v-361.38q-46.38-7.08-78.58-42.54-32.19-35.46-32.19-86.85V-860h40v269.23H300V-860h40v269.23h70.77V-860h40v269.23q0 51.39-32.19 86.85-32.2 35.46-78.58 42.54V-100h-40Zm369.23 0v-320h-98.46v-260q0-66.85 37.73-118.42 37.73-51.58 100.73-60.04V-100h-40Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerRestaurantIcon);
export default __webpack_public_path__ + "static/media/marker-restaurant-icon.66c35e9c98387ac0b0d7ed6ec5ebffd3.svg";
export { ForwardRef as ReactComponent };